import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import NotFound410Exception from "@/exceptions/NotFound410Exception";
import Redirection301Exception from "@/exceptions/Redirection301Exception";
export var api__getCarPriceDetails = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(req, postId) {
    var _res$data;
    var include, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (postId) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          include = "price";
          params = {
            id: postId,
            device_type: 'web',
            include: include
          };
          _context.n = 2;
          return fetcher(req).get("/post/view-online", {
            params: params
          });
        case 2:
          res = _context.v;
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data.price) || null);
      }
    }, _callee);
  }));
  return function api__getCarPriceDetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getNewPostViewData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(postId) {
    var _res$data2, _res$data3;
    var req,
      extra_includes,
      should_redirect,
      show_excluded_dealers,
      include,
      params,
      res,
      post,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          req = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
          extra_includes = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
          should_redirect = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 1;
          show_excluded_dealers = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : 0;
          include = "details,price,story,quality,meta,analytics,campaign,campaign_tags,g4Data,options,featuredImage,gallery_section,gallery,fuel,faqs,footerdetails,footer";
          if (extra_includes.length > 0) {
            include = include + "," + extra_includes.join(",");
          }
          params = {
            id: postId,
            thumb_size: 300,
            device_type: 'web',
            should_redirect: should_redirect,
            include: include
          };
          if (show_excluded_dealers) {
            params.show_excluded_dealers = 1;
          }
          _context2.n = 1;
          return fetcher(req).get("/post/view-online", {
            params: params
          });
        case 1:
          res = _context2.v;
          if (!((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === 230)) {
            _context2.n = 3;
            break;
          }
          if (!__IS_CSR__) {
            _context2.n = 2;
            break;
          }
          window.location.href = "?ref=post-404";
          return _context2.a(2, null);
        case 2:
          throw new NotFound410Exception(postId, 'api__getNewPostViewData code 230');
        case 3:
          post = (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data) || null;
          if (post) {
            _context2.n = 4;
            break;
          }
          return _context2.a(2, null);
        case 4:
          if (!post.fallback_url) {
            _context2.n = 5;
            break;
          }
          throw new Redirection301Exception(post.fallback_url, 'api__getNewPostViewData');
        case 5:
          return _context2.a(2, post);
      }
    }, _callee2);
  }));
  return function api__getNewPostViewData(_x3) {
    return _ref2.apply(this, arguments);
  };
}();